import { render } from "./MobileAccountDeleteConfirm.vue?vue&type=template&id=69cdd59e"
import script from "./MobileAccountDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./MobileAccountDeleteConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mobile/account_center/components/MobileAccountDeleteConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69cdd59e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69cdd59e', __exports__)) {
    api.reload('69cdd59e', __exports__)
  }
  
  module.hot.accept("./MobileAccountDeleteConfirm.vue?vue&type=template&id=69cdd59e", () => {
    api.rerender('69cdd59e', render)
  })

}


export default __exports__